module.exports = __webpack_public_path__ + "media/outgoing-call.656a9432.wav";